import React,{PureComponent} from 'react';
import {connect} from 'react-redux';

import Header from 'components/Header';
import Footer from 'components/Footer';

import {validateToken,logout} from 'actions';

class Index extends PureComponent{
    componentWillMount(){
        if(this.props.authenticated){
            this.props.validateToken();
        }
    }
    render(){
        return(
            <div className="cl-app">
                <Header 
                    authFromMobile={this.props.mobile}
                    loggedIn={this.props.authenticated} 
                    logout={this.props.logout}
                    userName={this.props.userName}
                    clientName={this.props.clientName}
                    authoriseFlow={this.props.authoriseFlow}/>
                <main>
                    {this.props.children}
                </main>
                <Footer/>
            </div>
        )
    }
}

function mapStateToProps(state){
    return {
        authenticated:state.auth.authenticated,
        mobile:state.auth.mobile,
        authoriseFlow:state.auth.authoriseFlow,
        userName: state.user.userName,
        clientName: state.user.clientName,
    }
}

export default connect(mapStateToProps,{validateToken,logout})(Index);


// WEBPACK FOOTER //
// ./src/scenes/index.js